const actionScope = '[Application Version]';

export class LoadApplicationVersion {
  static readonly type = `${actionScope} Load Application Version`;
}
